/* The frame every way into the dashboard shares — sign in, create your
   account, reset your password: the trasse mark, the form column, a line at
   the foot, and the day map on the right (from SiteSignIn.dc.html). Wraps
   itself in `.site`, so a page rendered outside SiteLayout still gets the
   site's type and fields (Gabriel, 2026-10-28: nothing on the way in should
   look like the old admin console). */
import React from 'react';
import './site.css';
import { useSiteGo } from './kit';
import MapD2BD5F from './maps/MapD2BD5F';

const AuthFrame: React.FC<{ children: React.ReactNode; foot?: React.ReactNode }> = ({ children, foot }) => {
  const go = useSiteGo();
  return (
    <div className="site">
      <div style={{ minHeight: '100vh', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)' }} className="sgrid">
        <div style={{ padding: '32px 40px', display: 'flex', flexDirection: 'column' }}>
          <div>
            <a {...go('SiteHome')} style={{ display: 'inline-flex', alignItems: 'center', gap: '9px', color: 'var(--ink)' }} aria-label="Trasse home">
              <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden="true">
                <rect width="28" height="28" rx="7" fill="var(--ink)" />
                <path d="M10 7.5v10.2c0 2.2 1.2 3.3 3.3 3.3H17M7.5 11.5H17" stroke="var(--paper)" strokeWidth="2.6" fill="none" strokeLinecap="round" />
                <circle cx="20.5" cy="21" r="2.2" fill="#0FB8CE" />
              </svg>
              <span style={{ fontFamily: "'Barlow Semi Condensed', sans-serif", fontWeight: '700', fontSize: '22px', letterSpacing: '-.01em' }}>
                trasse
              </span>
            </a>
          </div>
          <div style={{ flex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '64px 0' }}>
            <div style={{ width: '100%', maxWidth: '400px' }}>{children}</div>
          </div>
          {foot !== undefined ? foot : (
            <p className="xs" style={{ margin: '0', color: 'var(--muted)' }}>
              New school?{' '}
              <a className="lnk" {...go('SiteBook')}>
                Book a free pilot
              </a>
            </p>
          )}
        </div>
        <div className="desk mapday" style={{ position: 'relative', overflow: 'hidden', borderLeft: '1px solid var(--line)', display: 'block' }}>
          <MapD2BD5F />
          <div style={{ position: 'absolute', left: '40px', right: '40px', bottom: '40px' }}>
            <div style={{ background: 'rgba(255,255,255,.94)', backdropFilter: 'blur(20px)', borderRadius: '18px', padding: '12px 14px', display: 'flex', gap: '11px', boxShadow: '0 10px 30px -10px rgba(15,20,25,.25), 0 0 0 1px rgba(15,20,25,.05)' }}>
              <span style={{ width: '34px', height: '34px', borderRadius: '9px', background: '#0F1419', flex: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="18" height="18" viewBox="0 0 28 28" aria-hidden="true">
                  <path d="M10 7.5v10.2c0 2.2 1.2 3.3 3.3 3.3H17M7.5 11.5H17" stroke="#fff" strokeWidth="2.8" fill="none" strokeLinecap="round" />
                  <circle cx="20.5" cy="21" r="2.4" fill="#0FB8CE" />
                </svg>
              </span>
              <span style={{ display: 'flex', flexDirection: 'column', minWidth: '0', flex: '1' }}>
                <span style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#6B7176' }}>
                  <span style={{ fontWeight: '600', letterSpacing: '.02em' }}>TRASSE</span>
                  <span>7:08</span>
                </span>
                <span style={{ fontSize: '15px', fontWeight: '600', lineHeight: '20px', color: '#0F1419' }}>
                  Amara arrived at school
                </span>
                <span style={{ fontSize: '14px', lineHeight: '19px', color: '#3B4248' }}>
                  Dropped at Gate B · 7:08
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/** The site's error line under a form: red, with the circled "!". */
export const AuthError: React.FC<{ id?: string; children: React.ReactNode }> = ({ id, children }) => (
  <span className="ferr-msg" id={id} role="alert">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true" style={{ flex: 'none' }}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v5M12 16.5v.5" />
    </svg>
    {children}
  </span>
);

export default AuthFrame;
